import common from './common';

var environment = process.env.REACT_APP_ENV || 'development';
var envConfig = require('./' + environment);

var config = {
  ...common,
  ...envConfig.default,
  environment
};

export default config;
